import { Formik, Form, Field } from "formik";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import FormikInput from "src/components/formik/FormikInput";
import FormikSelect from "src/components/formik/FormikSelect";
import Table from "src/components/table/Table";
import { PAYMENT_MODE_TYPES_LIST } from "../product-container/ProductConstants";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import FormikRadio from "src/components/formik/FormikRadio";
import { commissionSearchAPI } from "src/api/CommissionApi";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { commissionSearchAction } from "../commission-container/actions/CommissionActions";
import { customerSearchAPI } from "src/api/CustomerApi";
import { DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import PropTypes from "prop-types";
import { customerSearchAction } from "../customer-container/actions/CustomerActions";
import { userSearchAPI } from "src/api/UserApi";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import { PAYOUT } from "../company-container/CompanyConstants";
import { casePaymentCreateAPI, caseReceiptCreateAPI, caseSearchAPI } from "src/api/CaseApi";
import UsePermission from "src/hoc/UsePermission";
import { cloneDeep } from "lodash";
import { caseSearchAction, caseUpsertAction } from "../case-container/actions/CaseActions";
import { includeStamp } from "src/utils/StampUtils";
const Render = (props) => {
  const {
    comissionDisplay,
    comissionModalClass,
    handleClose,
    values,
    targetData,
    handleCommissionChange,
    onSubmit,
    recieptDetails,
    permission,
    removePayment,
    caseForViewComission,
    handleShowDetails,
    showDetails,
    paymentDetails,
    handleTargetChange,
    handlePayToChange,
    selectedTarget,
    selectedPayTo,
  } = props;
  // 
  //console.log("value", values);
  // console.log("recieptDetails", recieptDetails.dueAmount);
return (
    <Form>
      <div
        className={`modal fade ${comissionModalClass}`}
        id="authAlert"
        style={{
          display: `${comissionDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-between align-items-center">
              <h5 className="modal-title mb-0">
                Selected Loan Date: {new Date(values?.caseDetails?.meta?.loanDate).toLocaleDateString("en-IN")}
              </h5>
              <div className="d-flex">
                <button type="button" className="btn btn-light mr-2" onClick={() => handleShowDetails()}>
                  {showDetails ? <i className="fas fa-eye" /> : <i className="fas fa-eye-slash" />}
                </button>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={handleClose}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            {showDetails && (
              <div className="row p-4">
                <div className="form-group col-md-2">
                  <h6 className="mb-1">Customer Name</h6>
                  <p className="mb-0">
                    {values?.customerDetails?.firstName || ""}{" "}
                    {values?.customerDetails?.lastName || ""}
                  </p>
                  <hr />
                  <h6 className="mb-1">Account Number</h6>
                  <p className="mb-0">
                    {values?.caseDetails?.meta?.LoanAccountNo || ""}
                  </p>
                  <hr />
                  <h6 className="mb-1">Loan Type</h6>
                  <p className="mb-0">{values?.caseDetails?.meta?.loanType}</p>
                  <hr />
                  <h6 className="mb-1">Gross Loan Amount</h6>
                  <p className="mb-0">
                    {values?.caseDetails?.meta?.grossLoanAmount}
                  </p>
                  <hr />
                </div>
                <div className="col-md-1 border-right"></div>{" "}
                {/* Vertical line */}
                <div className="form-group col-md-9">
                  <div className="modal-body">
                    <div className="row">
                          <div className="form-group col-md-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="bankAgntPay"
                            id="receivedFromBank"
                            value="receivedFromBank"
                            checked={selectedPayTo === 'receivedFromBank'}
                            onChange={(e) => handlePayToChange(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="receivedFromBank">
                            Received from Bank
                          </label>
                        </div>
                      </div>
                      <div className="form-group col-md-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="bankAgntPay"
                            id="payedToAgent"
                            value="payedToAgent"
                            checked={selectedPayTo === 'payedToAgent'}
                            onChange={(e) => handlePayToChange(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="payedToAgent">
                            Pay to Agent
                          </label>
                        </div>
                      </div>
                      {selectedPayTo === 'receivedFromBank' && (
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Commission Name</label>
                            <select
                              name="comissionName"
                              className="form-control"
                              onChange={(e) => handleCommissionChange(e.target.value)}
                              value={values?.comissionName}
                            >
                              <option value="" key="default">
                                Choose a commission...
                              </option>
                              {values?.commission?.COMISSION_TYPE_LIST?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}

                      {selectedPayTo === 'payedToAgent' && (
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Target Name</label>
                            <select
                              name="targetName"
                              className="form-control"
                              onChange={(e) => handleTargetChange(e.target.value)}
                              value={values?.targetName}
                            >
                              <option value="" key="default">
                                Choose a target...
                              </option>
                              {values?.target?.TARGET_LIST?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                    </div>
                    
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Due Amount:</label>
                          <FormikInput
                            name="amountDue"
                            type="text"
                            value={selectedPayTo === 'payedToAgent'?recieptDetails.dueAmount:paymentDetails.dueAmount}
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Received till now</label>
                          <FormikInput
                            name="amountTill"
                            type="text"
                            value={selectedPayTo === 'payedToAgent'?recieptDetails.amount:paymentDetails.amount}
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Amount</label>
                          <FormikInput
                            name="amount"
                            type="text"
                            placeholder="Received Amount"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Mode of Payment</label>
                          {/* <FormikSelect
                            items={PAYMENT_MODE_TYPES_LIST}
                            name="mode"
                            className="form-control"
                          /> */}
                          <Field
                            type="text"
                            className="form-control"
                            disabled
                            value="NEFT_RTGS"
                            name="mode"
                            initialValue="NEFT_RTGS"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Transaction/Ref. No.</label>
                          <FormikInput
                            name="instrument_number"
                            type="text"
                            placeholder="Transaction/Ref. No."
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Payment Date</label>
                          <FormikDateTimePicker
                            name="date"
                            className="form-control"
                            disableClock
                            format="dd-MM-y"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer border-0">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onSubmit={onSubmit}

                    >
                      Pay
                    </button>
                    <hr />
                  </div>
                  <div className="card mt-3">
                    <div className="card-body">
                      <h5 className="card-title">Payments</h5>
                      <Table
                        hasRemove={permission}
                        removeClick={removePayment}
                        rowDeletedCheckPath="deleted"
                        recordsPerPage={4}
                        searchData={{
                          data:selectedPayTo === 'receivedFromBank'? values?.commission?.payments?.data:values?.target?.payments?.data,
                          count: selectedPayTo === 'receivedFromBank'? values?.commission?.payments?.count:values?.target?.payments?.count,
                          currentPage: 0,
                        }}
                        columns={{
                          payment_date: {
                            display: 'Payment Date',
                            path: 'date',

                          },
                          instrument_number: {
                            display: 'Instrument Number',
                            path: 'instrument_number',
                          },
                          bank_name: {
                            display: 'Name',
                            path: 'Name',
                          },
                          amount: {
                            display: 'Amount',
                            path: 'amount',
                          },
                          deletedTs: {
                            display: 'Deleted On',
                            path: 'deletedTs',
                          },
                          deletedBy: {
                            display: "Deleted By",
                            path: "updatedBy.personalInfo.firstName",
                          }
                        }}
                      />
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            )}
            <Table
              recordsPerPage={50}
              searchData={{
                data:selectedPayTo === 'receivedFromBank'? values?.commission?.data:values?.target?.data,
                count: selectedPayTo === 'receivedFromBank'? values?.commission?.count:values?.target?.count,
                currentPage: 0,
              }}
              columns={{
                group: [
                  {
                    display: "From Date",
                    // type: Date,
                    path: "FromDate",
                    // format: DATE_TIME_FORMAT.DATE,
                  },
                  {
                    display: "To Date",
                    // type: Date,
                    path: "ToDate",
                    // format: DATE_TIME_FORMAT.DATE || String,
                  },
                  {
                    display: "Name",
                    path: "Name",
                  },
                  {
                    display: 'Slab Target',
                    path: 'target'
                  },
                  {
                    display: "Reward %",
                    path: "reward",
                  },
                  {
                    display: "Amount",
                    path: "amount",
                  },
                  {
                    display: "Fulfilled Amount",
                    path: "receivedAmount",
                  },
                  {
                    display: "Short Amount",
                    path: "short",
                  },
                  {
                    display: "Completed",
                    path: "completed",
                  }, {
                    display: "By",
                    path: "by",
                  },
                ],
              }}
            />
          </div>
        </div>
      </div>
    </Form>
  );
};
const ComissionPopup = (props) => {
  const dispatch = useDispatch();
  const {
    comissionDisplay,
    caseForViewComission,
    comissionModalClass,
    closeAlertDialog,
    callFrom
  } = props;

  const [selectedPayTo,setSelectedPayTo]=useState('receivedFromBank');
  const [showDetails, setShowDetails] = useState(false)
  const [loading, setLoading] = useState(false);
  const [commissionData, setCommissionData] = useState([]);
  const [targetData, setTargetData] = useState([]);
  // const {
  //   search: { data: customerSearchresults = [] },
  // } = useSelector((state) => state.CustomerReducer);
  const [count, setCount] = useState(0);
  const [targetCount, setTargetCount] = useState(0);
  const [selectedTarget, setSelectedTarget] = useState(null);
  const [selectedCommission, setSelectedCommission] = useState(null);
  let intialRecieptDetails={
    dueAmount: 0,
    amount: 0,
  } 
  let intitialPaymentDetails={
    dueAmount: 0,
    amount: 0,
  }
  const [paymentDetails, setPaymentDetails] = useState(intitialPaymentDetails);
  const [recieptDetails, setRecieptDetails] = useState(intialRecieptDetails);
  const { meta = {} } = caseForViewComission || {};
  const [customerSearchresults, setCustomerSearchResults] = useState([])
  const [payments, setPayments] = useState([])
  const [recipets, setReciepts] = useState([])
  const viewComissionPaymentsPermissionRemove = UsePermission({
    scope: 'reports.payout_calculation.commission_payments.remove',
  });

  // Initialize initialValues with recieptDetails
  const initialValues = {
    amountDue: selectedPayTo === 'receivedFromBank'?recieptDetails.dueAmount:paymentDetails.dueAmount,
    amountTill: selectedPayTo === 'receivedFromBank'?recieptDetails.amount:paymentDetails.amount,
    amount: "",
    mode: "",
    instrument_number: "",
    date: null,
  };

  // useCallback for memoizing data fetching functions
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const { appliedCommissions = [],appliedTargets=[] } = caseForViewComission || {};
      setCount(appliedCommissions.length);
      setCommissionData(appliedCommissions);
      setTargetCount(appliedTargets.length);
      setTargetData(appliedTargets);

    } catch (error) {
      console.error("Error fetching commission/target data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [caseForViewComission]);

  const fetchCustomer = useCallback(async () => {
    try {
      setLoading(true);
      const { customerId } = caseForViewComission || {};
      if (!customerId) {
        setLoading(false);
        return;
      }
      const where = { _id: customerId };

      let {
        data: {
          data: { data: customer },
        },
      } = await customerSearchAPI({ where })

      setCustomerSearchResults(customer)
      // await dispatch(customerSearchAction({ where }));
    } catch (error) {
      console.error("Error fetching customer data:", error);
    } finally {
      setLoading(false);
    }
  }, [caseForViewComission]);

  // useEffect to trigger data fetching when necessary
  useEffect(() => {
    if (comissionDisplay && caseForViewComission) {
      fetchData();
      fetchCustomer();
    }
    setSelectedPayTo(callFrom)
  }, [comissionDisplay, caseForViewComission]);

  const getReceivedTill = (selectedCommission, commissionName) => {
    // Create a copy of the caseForViewComission.receiptDetails array
    const receiptsData = [...caseForViewComission.recieptDetails];

    // Find all matching receipts based on commissionId
    const matchingReceipts = receiptsData.filter(
      (receipt) => String(receipt.commissionId) === String(selectedCommission)
    );

    let totalAmount = 0;

    if (matchingReceipts.length > 0) {

      // Calculate the total amount from valid (not deleted) receipts
      totalAmount = matchingReceipts
        .filter((receipt) => !receipt.deleted)
        .reduce((sum, receipt) => sum + receipt.amount, 0);

      // Create a copy of the prevState receipts array
      setReciepts((prevState) => {
        const updatedReceipts = [...prevState];

        // Modify the copied matchingReceipt objects
        const modifiedMatchingReceipts = matchingReceipts.map((receipt) => {
          const copiedReceipt = { ...receipt };
          selectedCommission === '1'
            ? (copiedReceipt.Name = "Default Commission")
            : (copiedReceipt.Name = commissionName);
          copiedReceipt.date = formatDate(copiedReceipt.date);
          copiedReceipt.deletedTs = formatDate(copiedReceipt?.deletedTs);
          return copiedReceipt;
        });
        
         // Filter out existing receipts with the same _id as the modifiedMatchingReceipts
      const filteredReceipts = updatedReceipts.filter(
        (receipt) =>
          !modifiedMatchingReceipts.some((modifiedReceipt) => modifiedReceipt._id === receipt._id)
      );

        // Add the modified copiedMatchingReceipts to the filtered array
        return [...filteredReceipts, ...modifiedMatchingReceipts];
      });
    }

    return totalAmount;
  };

 const getPaidTill=(selectedTarget,targetName)=>{
      // Create a copy of the caseForViewComission.paymentDetails array
      const paymentData = [...caseForViewComission.paymentDetails];
      const matchingPayments=paymentData.filter(
        (payment)=>(String(payment.targetId) === String(selectedTarget))
        )

    let totalAmount = 0;

    if (matchingPayments.length > 0) {

      // Calculate the total amount from valid (not deleted) payments
      totalAmount = matchingPayments
        .filter((payment) => !payment.deleted)
        .reduce((sum, payment) => sum + payment.amount, 0);

      // Create a copy of the prevState payment array
      setPayments((prevState) => {
        const updatedPayments = [...prevState];

        // Modify the copied matchingPayments objects
        const modifiedMatchingPayments = matchingPayments.map((payment) => {
          const copiedPayment = { ...payment };
          selectedTarget === '1'
            ? (copiedPayment.Name = "Default Target")
            : (copiedPayment.Name = targetName);
            copiedPayment.date = formatDate(copiedPayment.date);
            copiedPayment.deletedTs = formatDate(copiedPayment?.deletedTs);
          return copiedPayment;
        });
        
         // Filter out existing payments with the same _id as the modifiedMatchingPayments
      const filteredPayments = updatedPayments.filter(
        (payment) =>
          !modifiedMatchingPayments.some((modifiedPayment) => modifiedPayment._id === payment._id)
      );

        // Add the modified copiedMatchingReceipts to the filtered array
        return [...filteredPayments, ...modifiedMatchingPayments];
      });
    }

    return totalAmount;
 }

 const removePayment = (record) => {
  const newRecord = cloneDeep(caseForViewComission);
  const timestamp = new Date();

  const markAsDeleted = (item) => {
    item.deleted = true;
    item.deletedTs = timestamp;
    includeStamp(item);
  };

  const findAndMarkDeleted = (details) => {
    const item = details.find((detail) => detail._id === record._id);
    if (item) {
      markAsDeleted(item);
    }
  };

  if (selectedPayTo === 'receivedFromBank') {
    findAndMarkDeleted(newRecord.recieptDetails);
  } else if (selectedPayTo === 'payedToAgent') {
    findAndMarkDeleted(newRecord.paymentDetails);
  }

  dispatch(caseUpsertAction(newRecord));
  handleClose();
};

  const getHighestSlab = (selectedId, type) => {
    let dataSet;

    if (type === "commission") {
        dataSet = commissionData;
    } else if (type === "target") {
        dataSet = targetData;
    } else {
        throw new Error('Invalid type. Must be either "commission" or "target".');
    }

    const highestSlab = dataSet
      .find(
        (item) => String(item._id) === String(selectedId)
      )
      .slabs.reduce((highest, currentSlab) => {
        // If current slab's target is higher and completed is true:
        if (
          currentSlab.target > (highest?.target || 0)
          && currentSlab.completed === true
        ) {
          return currentSlab;
        }
        // Otherwise, return the previous highest slab (or undefined initially)
        return highest;
      }, 0);

    return highestSlab;
};

const getPayout = (caseInfo, selectedId, type) => {
  // Check if the selectedId is not "1" and determine the type
  if (selectedId !== "1") {
      return getHighestSlab(selectedId, type);
  }

  // Calculate default commission/target
  let amount = 0;
  const duePercentage = caseInfo?.companyCommissionPercentage || 0;
  const payoutPercentage = caseInfo?.agentCommissionPercentage || 0;

  const increasedDuePercentage = duePercentage + (duePercentage * 0.09);
  const payInPercentage = (caseInfo?.companyId?.companyName === 'HDFC BANK' && caseInfo?.companyId?.usedGSTCalc === "usedIsExclusiveHalf") ? increasedDuePercentage : duePercentage;
  const percentage = type === "target" ? payoutPercentage : payInPercentage;

  switch (caseInfo?.companyId?.payOut) {
      case PAYOUT.LOANAMT:
          amount = Math.round(
              ((caseInfo?.meta?.loanAmount || 0) -
              (caseInfo?.meta?.EMIAmount || 0) *
              (caseInfo?.meta?.EMIAdvance || 0) *
              (percentage)) /
              100, 2
          );
          break;
      case PAYOUT.LOANAMT_CROSSSALE:
          amount = Math.round(
              (((caseInfo?.meta?.loanAmount || 0) -
              (caseInfo?.meta?.EMIAmount || 0) *
              (caseInfo?.meta?.EMIAdvance || 0) +
              (caseInfo?.meta?.crossSaleAmount || 0)) *
              (percentage)) /
              100, 2
          );
          break;
      case PAYOUT.LOANAMT_LESS_PF:
          amount = Math.round(
              (((caseInfo?.meta?.loanAmount || 0) -
              (caseInfo?.meta?.EMIAmount || 0) *
              (caseInfo?.meta?.EMIAdvance || 0) -
              (caseInfo?.meta?.processingFees || 0)) *
              (percentage)) /
              100, 2
          );
          break;
      default:
          amount = Math.round(
              (((caseInfo?.meta?.loanAmount || 0) -
              (caseInfo?.meta?.EMIAmount || 0) *
              (caseInfo?.meta?.EMIAdvance || 0) +
              (caseInfo?.meta?.crossSaleAmount || 0) -
              (caseInfo?.meta?.processingFees || 0)) *
              (percentage)) /
              100, 2
          );
  }

  return isNaN(amount) ? 0 : amount;
};

  const formatDate = (date) => {
    //Only accept Iso 8601 date like : 2024-03-19T18:30:00.000Z and convert them into dd/mm/yy like: 20/03/2024
    const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|(\+|-)\d{2}:\d{2})?$/;
    if (regex.test(date)) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        separator: "/",
      });
    } else {
      return date
    }
  }

  const getByFor = (id, type) => {
    let data, idKey;

    if (type === 'commission') {
        data = recipets;
        idKey = 'commissionId';
    } else if (type === 'target') {
        data = payments;
        idKey = 'targetId';
    } else {
        throw new Error('Invalid type. Must be either "commission" or "target".');
    }

    if (!data || data.length === 0) {
      return null;
    }

    // Find all matching items for the given id
    const matchingItems = data.filter(item => item.idKey === id);

    // Filter out the deleted items
    const validItems = matchingItems.filter(item => !item.deleted);

    if (validItems.length === 0) {
      return null;
    }

    const firstValidItem = validItems[0];
    return firstValidItem.by.personalInfo.firstName;
};

  // useMemo to memoize commission data processing
  const preparedData = useMemo(() => {
    if (!caseForViewComission || !customerSearchresults) return null;
  
    const commonData = {
      caseDetails: caseForViewComission,
      customerDetails: customerSearchresults[0],
      grossLoanAmount: meta?.grossLoanAmount || 0,
    };
  
    // Commission data processing
    const defaultCommission = {
      ToDate: 'Monthly',
      FromDate: formatDate(meta?.loanDate) || "Monthly",
      Name: "Default Commission",
      receivedAmount: getReceivedTill("1"),
      target: "Monthly",
      amount: getPayout(caseForViewComission, "1", "commission"),
      grossLoanAmount: commonData.grossLoanAmount,
      short: Math.max(0, getPayout(caseForViewComission, "1", "commission") - getReceivedTill("1")),
      reward: caseForViewComission?.companyCommissionPercentage || 0,
      completed: true,
      by: getByFor("1", "commission")
    };
  
    const processedCommissionData = [defaultCommission].concat(
      commissionData?.length > 0
        ? commissionData.flatMap((commissionInfo) => {
            if (!Array.isArray(commissionInfo.slabs)) {
              console.error("Commission slab is not an array");
              return [];
            }
  
            let highestSlab = getHighestSlab(String(commissionInfo._id), "commission");
            if (!highestSlab || highestSlab === 0) return [];
  
            const copiedCommissionInfo = {
              ...commissionInfo,
              ...highestSlab,
              Name:commissionInfo.commissionName,
              ToDate: formatDate(commissionInfo?.ToDate),
              FromDate: formatDate(commissionInfo.FromDate),
              amount: parseInt((commonData.grossLoanAmount * highestSlab.reward) / 100),
              receivedAmount: getReceivedTill(String(commissionInfo._id), commissionInfo.commissionName),
              by: getByFor(String(commissionInfo._id), "commission")
            };
  
            copiedCommissionInfo.short = Math.max(0, copiedCommissionInfo.amount - copiedCommissionInfo.receivedAmount);
  
            return [copiedCommissionInfo];
          })
        : []
    );
  
    const COMISSION_TYPE_LIST = [
      { value: "1", label: "Default Commission" },
      ...commissionData?.map(info => ({ value: info._id, label: info.commissionName })) || []
    ];
  
    // Target data processing
    const defaultTarget = {
      ToDate: 'Monthly',
      FromDate: formatDate(meta?.loanDate) || "Monthly",
      Name: "Default Target",
      receivedAmount: getPaidTill("1"),
      target: "Monthly",
      amount: getPayout(caseForViewComission, "1", "target"),
      grossLoanAmount: commonData.grossLoanAmount,
      short: Math.max(0, getPayout(caseForViewComission, "1", "target") - getPaidTill("1")),
      reward: caseForViewComission?.agentCommissionPercentage || 0,
      completed: true,
      by: getByFor("1", "target")
    };
  
    const processedTargetData = [defaultTarget].concat(
      targetData?.length > 0
        ? targetData.flatMap((targetInfo) => {
            if (!Array.isArray(targetInfo.slabs)) {
              console.error("Target slab is not an array");
              return [];
            }
  
            let highestSlab = getHighestSlab(String(targetInfo._id), "target");
            if (!highestSlab || highestSlab === 0) return [];
  
            const copiedTargetInfo = {
              ...targetInfo,
              ...highestSlab,
              Name:targetInfo.targetName,
              ToDate: formatDate(targetInfo?.ToDate),
              FromDate: formatDate(targetInfo.FromDate),
              amount: parseInt((commonData.grossLoanAmount * highestSlab.reward) / 100),
              receivedAmount: getPaidTill(String(targetInfo._id), targetInfo.targetName),
              by: getByFor(String(targetInfo._id), "target")
            };
  
            copiedTargetInfo.short = Math.max(0, copiedTargetInfo.amount - copiedTargetInfo.receivedAmount);
  
            return [copiedTargetInfo];
          })
        : []
    );
  
    const TARGET_LIST = [
      { value: "1", label: "Default Target" },
      ...targetData?.map(info => ({ value: info._id, label: info.targetName })) || []
    ];
  
    return {
      ...commonData,
      commission: {
        data: processedCommissionData,
        COMISSION_TYPE_LIST,
        payments: {
          data: [...recipets],
          count: recipets?.length
        },
        count: Math.max(count, 1+count),
      },
      target: {
        data: processedTargetData,
        TARGET_LIST,
        payments: {
          data: [...payments],
          count: payments?.length
        },
        count: Math.max(targetCount, 1+targetCount),
      }
    };
  }, [commissionData, targetData, caseForViewComission, customerSearchresults]);

  const handleCommissionChange = (selectedCommission) => {
    if(!selectedCommission || selectedCommission==="" ) {
      setRecieptDetails(intialRecieptDetails)
     return
    }

    setSelectedCommission(selectedCommission);
    let updatedReceiptDetails;

    // If caseForViewCommission has receiptDetails array
    if (caseForViewComission && caseForViewComission.receiptDetails) {
      // Find all matching receipt objects based on commissionId
      const matchingReceipts = caseForViewComission.receiptDetails.filter(
        (receipt) => String(receipt.commissionId) === String(selectedCommission)
      );

      // If matching receipts found and not deleted, calculate values
      const validMatchingReceipts = matchingReceipts.filter((receipt) => !receipt.deleted);
      if (validMatchingReceipts.length > 0) {
        let highestSlabDue = getPayout(caseForViewComission, selectedCommission,"commission").target;
        highestSlabDue = isNaN(highestSlabDue) ? 0 : highestSlabDue;
        let dueAmount =
          parseInt((meta?.grossLoanAmount * caseForViewComission?.companyCommissionPercentage) / 100) -
          validMatchingReceipts.reduce((sum, receipt) => sum + receipt.amount, 0);
        updatedReceiptDetails = {
          dueAmount: dueAmount >= 0 ? dueAmount : 0 | 0,
          amount: validMatchingReceipts.reduce((sum, receipt) => sum + receipt.amount, 0),
        };
      }
    }

    // If caseForViewCommission has no receiptDetails array or no matching receipt found or the payment was marked deleted
    if (!updatedReceiptDetails) {
      if (selectedCommission === "1") {
        // let getPay = parseInt((meta?.grossLoanAmount * caseForViewComission?.companyCommissionPercentage) / 100);
        let getPay = getPayout(caseForViewComission, selectedCommission,"commission");
        let getRcv = getReceivedTill(selectedCommission);
        let payout = getPay < 0 ? 0 : getPay - getRcv;
        payout = isNaN(payout) ? 0 : payout;
        updatedReceiptDetails = {
          dueAmount: payout,
          amount: getReceivedTill(selectedCommission),
        };
      } else {
        let highestSlab = getHighestSlab(selectedCommission,"commission");
        let getPay = parseInt((meta?.grossLoanAmount * highestSlab.reward) / 100);
        let getRcv = getReceivedTill(selectedCommission);
        let payout = getPay < 0 ? 0 : getPay - getRcv;
        payout = isNaN(payout) ? 0 : payout;
        updatedReceiptDetails = {
          dueAmount: payout,
          amount: getReceivedTill(selectedCommission),
        };
      }
    }

    setRecieptDetails(updatedReceiptDetails);
  };

  const handleTargetChange = (selectedTarget) => {
    if (!selectedTarget || selectedTarget === "") {
      setPaymentDetails(intitialPaymentDetails);
      return;
    }
  
    setSelectedTarget(selectedTarget);
    let updatedPaymentDetails;
  
    // If caseForViewCommission has paymentDetails array
    if (caseForViewComission && caseForViewComission.paymentDetails) {
      // Find all matching payment objects based on targetId
      const matchingPayments = caseForViewComission.paymentDetails.filter(
        (payment) => String(payment.targetId) === String(selectedTarget)
      );
  
      // If matching payments found and not deleted, calculate values
      const validMatchingPayments = matchingPayments.filter((payment) => !payment.deleted);
      if (validMatchingPayments.length > 0) {
        let highestSlabDue = getPayout(caseForViewComission, selectedTarget, "target").target;
        highestSlabDue = isNaN(highestSlabDue) ? 0 : highestSlabDue;
        let dueAmount =
          parseInt((meta?.grossLoanAmount * caseForViewComission?.agentCommissionPercentage) / 100) -
          validMatchingPayments.reduce((sum, payment) => sum + payment.amount, 0);
        updatedPaymentDetails = {
          dueAmount: dueAmount >= 0 ? dueAmount : 0,
          amount: validMatchingPayments.reduce((sum, payment) => sum + payment.amount, 0),
        };
      }
    }
  
    // If caseForViewCommission has no paymentDetails array or no matching payment found or the payment was marked deleted
    if (!updatedPaymentDetails) {
      if (selectedTarget === "1") {
        let getPay = getPayout(caseForViewComission, selectedTarget, "target");
        let getPaid = getPaidTill(selectedTarget);
        let payout = getPay < 0 ? 0 : getPay - getPaid;
        payout = isNaN(payout) ? 0 : payout;
        updatedPaymentDetails = {
          dueAmount: payout,
          amount: getPaidTill(selectedTarget),
        };
      } else {
        let highestSlab = getHighestSlab(selectedTarget, "target");
        let getPay = parseInt((meta?.grossLoanAmount * highestSlab.reward) / 100);
        let getPaid = getPaidTill(selectedTarget);
        let payout = getPay < 0 ? 0 : getPay - getPaid;
        payout = isNaN(payout) ? 0 : payout;
        updatedPaymentDetails = {
          dueAmount: payout,
          amount: getPaidTill(selectedTarget),
        };
      }
    }
  
    setPaymentDetails(updatedPaymentDetails);
  };

  const handlePayToChange=(value)=>{
    setSelectedPayTo(value)
  }

 const onSubmit = useCallback(async (values, formikUtils) => {
  const { amountDue, amount, mode, instrument_number, date } = values;

  if (parseInt(amountDue) < parseInt(amount)) {
    alert("The Amount should be less than or equal to pending amount.");
    formikUtils.setSubmitting(false);
    return;
  }

  if (amountDue < 1 || amount < 1 || isNaN(amount)) {
    alert("Due amount can't be 0");
    formikUtils.setSubmitting(false);
    return;
  }

  const commonPayloadData = {
    amount: parseInt(amount),
    mode,
    instrument_number,
    date,
  };

  let caseId = caseForViewComission._id;
  let payloadData = {};
  let apiFunction = null;

  if (selectedPayTo === 'receivedFromBank') {
    payloadData = {
      values: {
        commissionId: String(selectedCommission),
        ...commonPayloadData,
      },
    };
    apiFunction = caseReceiptCreateAPI;
  } else if (selectedPayTo === 'payedToAgent') {
    payloadData = {
      values: {
        targetId: String(selectedTarget),
        ...commonPayloadData,
      },
    };
    apiFunction = casePaymentCreateAPI;
  }

  if (apiFunction) {
    includeStamp(payloadData.values);
    await apiFunction(caseId, payloadData);
    handleClose();
    dispatch(headerShowAction({ data: `Updated successfully` }));
  }

  formikUtils.setSubmitting(false);
}, [selectedPayTo, selectedCommission, selectedTarget, caseForViewComission]);



  const handleClose = () => {
    setLoading(false)
    setCount(0)
    setTargetCount(0)
    // setSelectedCommission(null)
    setRecieptDetails(intialRecieptDetails)
    setPaymentDetails(intitialPaymentDetails)
    setReciepts([])
    setPayments([])
    closeAlertDialog("Comission");
    setCommissionData([])
    setTargetData([])
    setSelectedPayTo('')
    setShowDetails(false)
  }

  const handleShowDetails = () => {
    setShowDetails(!showDetails)
  }
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formikProps) =>
          <Render
            {...formikProps}
            comissionDisplay={comissionDisplay}
            comissionModalClass={comissionModalClass}
            handleClose={handleClose}
            values={preparedData}
            loading={loading}
            handleCommissionChange={handleCommissionChange}
            recieptDetails={recieptDetails}
            paymentDetails={paymentDetails}
            permission={viewComissionPaymentsPermissionRemove}
            removePayment={removePayment}
            caseForViewComission={caseForViewComission}
            handleShowDetails={handleShowDetails}
            showDetails={showDetails}
            handleTargetChange={handleTargetChange}
            handlePayToChange={handlePayToChange}
            selectedTarget={selectedTarget}
            selectedPayTo={selectedPayTo}
          />

        }
      </Formik>
    </>
  );
};
export default ComissionPopup;
